export default "__VITE_ASSET__IREhvY$0__"